import { AdminSearchQuery_adminSearch_results } from './__generated__/AdminSearchQuery'

const urlForItem = (item: AdminSearchQuery_adminSearch_results) => {
  if (item.__typename === 'Kit') {
    return `/dashboard/kit/${item.id}`
  }

  if (item.__typename === 'Order') {
    return `/dashboard/order/${item.id}`
  }

  if (item.__typename === 'RecoveryCertificate') {
    return `/dashboard/recovery-certificates/${item.orderId}`
  }
}

export default urlForItem
